import ImageCarousel from './ImageCarousel';


const Pictures = () => {
    return ( 
    <div>      
          <h2>OUR FLOW WALL DESKs</h2>

        <div className="pictures">
        <br />
            <div className="carossal">
            <ImageCarousel />

            </div>
            </div>
        </div>
     );
}
 
export default Pictures;